import Vue from "vue"

import isPlainObject from "lodash/isPlainObject"

/* import mediaApi from "../../api/media" */
import utilsApi from "../../api/utils"
const initialObject = {
  _id: undefined,
  id: undefined,
  alt: undefined,
  title: undefined,
  thumbnail: undefined,
  format: undefined,
  mediaType: undefined,
  tags: undefined,
  uploaded_by: undefined,
  createdAt: undefined,
  updatedAt: undefined
}
const ignoreObjectsFields = ["createdAt", "updatedAt"]
// general state for the site

const initialState = {
  media: [],
  count: 0,
  page: 1,
  fetched: false,
  error: false,
  object: initialObject,
  isNew: false,
  selected: []
}

const state = Object.assign({}, initialState)

const getters = {
  media: (state) => state.media,
  mediaIndex: (state) => (payload) => {
    const { param, parent, key } = payload || {}
    return payload
      ? param
        ? key
          ? parent
            ? state[param] && state[param][parent] && state[param][parent][key]
              ? state[param][parent][key]
              : undefined
            : state[param] && state[param][key]
            ? state[param][key]
            : undefined
          : state[param]
          ? state[param]
          : undefined
        : state
      : state
  },
  mediaError: (state) => state.error,
  media_Object: (state) => state.object,
  media_selected: (state) => state.selected
}
const actions = {
  async DELETE_media({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.deleteObject("media", object)
    if (apiResponse != null) {
      //console.log("DELETE_COLLECTIONS", apiResponse, object)
      dispatch("FETCH_PAGE_media", state.page)
      return true
    } else {
      commit("PRODUCTCOLLECTIONS_ERROR")
      return false
    }
  },
  async DELETE_SELECTED_media({ state, dispatch, commit }) {
    let deletions = await Promise.all(
      state.selected.map(async (current) => {
        return await dispatch("DELETE_media", current)
      })
    )
    if (deletions.includes(false)) {
      return false
    } else {
      commit("SET_media", {
        param: "selected",
        value: []
      })
      return true
    }
  },
  UPDATE_mediaState({ commit }, payload) {
    commit("SET_media", payload)
    return true
  },
  async UPDATE_media({ commit, dispatch, state }, object) {
    const filtered = Object.keys(object)
      .filter((key) => !ignoreObjectsFields.includes(key))
      .reduce((obj, key) => {
        obj[key] = object[key]
        return obj
      }, {})
    let apiResponse = await utilsApi.updateObject("media", filtered)
    if (apiResponse != null) {
      //commit("MEDIA_SETTING", apiResponse)
      dispatch("FETCH_PAGE_media", state.page)
      return true
    } else {
      commit("MEDIA_ERROR")
      return false
    }
  },
  async CREATE_media({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.createObject("media", object)
    if (apiResponse != null) {
      commit("MEDIA_SETTING", apiResponse)
      dispatch("FETCH_PAGE_media", state.page)
      return true
    } else {
      commit("MEDIA_ERROR")
      return false
    }
  },
  async FETCH_media({ commit }) {
    let apiResponse = await utilsApi.getObjects("media")
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("MEDIA_SETTING", apiResponse)
      return true
    } else {
      commit("MEDIA_ERROR")
      return false
    }
  },

  async FETCH_PAGE_media({ commit }, page) {
    let apiResponse = await utilsApi.getObjectsPage("media", page)
    if (apiResponse != null) {
      commit("MEDIA_SETTING", { ...apiResponse, page })
      return true
    } else {
      commit("MEDIA_ERROR")
      return false
    }
  },

  UPDATE_OBJECT_media({ commit }, payload) {
    commit("SET_OBJECT_MEDIA", payload)
    return true
  },
  CLEAN_OBJECT_media({ commit }) {
    commit("SET_OBJECT_MEDIA_INITIAL")
    return true
  },
  async CLEAN_STORE_media({ commit }) {
    const initialStateKeys = Object.keys(initialState)
    await Promise.all(
      initialStateKeys.map(async (current) => {
        await commit("SET_media", {
          param: current,
          value: initialState[current]
        })
        return true
      })
    )
    return true
  },
  UPDATE_SELECTED_media({ commit }, payload) {
    if (
      payload &&
      isPlainObject(payload) &&
      Object.prototype.hasOwnProperty.call(payload, "field")
    ) {
      commit("SET_SELECTED_MEDIA", payload.value)
    } else {
      commit("SET_SELECTED_MEDIA", payload)
    }
    return true
  },
  UPDATE_SELECTED_FROM_ID_media({ commit, state }, payload) {
    //console.log("ESTO LLEGO A UPDT SELECTED FR ID", payload)
    let response
    if (typeof payload == Array) {
      response = payload.value.map((option) => {
        if (
          state.media.find((mediaOption) => {
            mediaOption._id = option
          })
        ) {
          return option
        }
      })
      //console.log("UPT SLCT FR ID ARRAY", response)
    } else if (payload !== undefined) {
      response = state.media.find((mediaOption) => {
        return mediaOption._id == payload.value
      })
      //console.log("UPT SLCT FR ID STRING", response)
    } else {
      return {}
    }
    commit("SET_SELECTED_MEDIA", response)

    return true
  }
}
const mutations = {
  MEDIA_SETTING: (state, { media, count = false, page }) => {
    //console.log("SETTING MEDIA", media)
    state.count = count || state.media.length
    state.page = page || state.page
    state.media = media
    state.fetched = true
    state.error = false
  },
  MEDIA_ERROR: (state) => {
    state.media = null
    state.fetched = true
    state.error = false
  },
  SET_MEDIA_FIELD: (state, payload) => {
    state.object[payload.field] = payload.value
  },
  SET_MEDIA_CHILD_FIELD: (state, payload) => {
    state.object[payload.parent][payload.field] = payload.value
  },
  SET_OBJECT_MEDIA: (state, payload) => {
    Object.keys(initialObject).map((key) => {
      state.object[key] = payload[key]
    })
  },
  SET_SELECTED_MEDIA: (state, payload) => {
    state.selected = payload
  },
  SET_OBJECT_MEDIA_INITIAL: (state) => {
    state.object = { ...initialObject }
  },
  SET_media: (state, payload) => {
    const { param, parent, key, value } = payload
    //console.log("SETTING FORMS STATE IN", param, value, key, parent)
    key
      ? parent
        ? state[param]
          ? state[param][parent]
            ? Vue.set(state[param][parent], key, value)
            : Vue.set(state[param], parent, {}) &&
              Vue.set(state[param][parent], key, value)
          : Vue.set(state, param, {}) &&
            Vue.set(state[param], parent, {}) &&
            Vue.set(state[param][parent], key, value)
        : state[param]
        ? Vue.set(state[param], key, value)
        : Vue.set(state, param, {}) && Vue.set(state[param], key, value)
      : Vue.set(state, param, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
